import type { ContentObjectDetail, ContentObjectList } from 'models';
import { canLikeContentObject } from './can-like-content-object';

export const canSeeContentObjectLikes = ({
  contentObject,
}: {
  contentObject: ContentObjectDetail | ContentObjectList;
}) => canLikeContentObject({ contentObject });
